import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=0022bc10&scoped=true&lang=html"
import script from "./TemplatesList.vue?vue&type=script&lang=js"
export * from "./TemplatesList.vue?vue&type=script&lang=js"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=0022bc10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022bc10",
  null
  
)

export default component.exports